import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;

  flex-direction: column;

  flex: 1;

  align-items: center;
  justify-content: space-between;
`

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
`
